var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActionsLabelIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.7792 10.3501L7.61539 2.89857V5.875V6.68766L8.41087 6.85386L12.2208 7.64987L6.38462 15.1014V12.125V11.3123L5.58913 11.1461L1.7792 10.3501Z",
    className: "iconStroke",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 12H18",
    className: "iconStroke",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 17H18",
    className: "iconStroke",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionsLabelIcon);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEuNzc5MiAxMC4zNTAxTDcuNjE1MzkgMi44OTg1N1Y1Ljg3NVY2LjY4NzY2TDguNDEwODcgNi44NTM4NkwxMi4yMjA4IDcuNjQ5ODdMNi4zODQ2MiAxNS4xMDE0VjEyLjEyNVYxMS4zMTIzTDUuNTg5MTMgMTEuMTQ2MUwxLjc3OTIgMTAuMzUwMVoiIGNsYXNzPSJpY29uU3Ryb2tlIiBzdHJva2Utd2lkdGg9IjIiLz4KPHBhdGggZD0iTTEzIDEySDE4IiBjbGFzcz0iaWNvblN0cm9rZSIgc3Ryb2tlLXdpZHRoPSIyIi8+CjxwYXRoIGQ9Ik0xMCAxN0gxOCIgY2xhc3M9Imljb25TdHJva2UiIHN0cm9rZS13aWR0aD0iMiIvPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };